import type { SVGProps } from 'react';
const SvgStatisticSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.88}
      d="M14.714 13H2.428V1.859a.143.143 0 0 0-.143-.143h-1a.143.143 0 0 0-.142.143v12.285c0 .079.064.143.142.143h13.429a.143.143 0 0 0 .143-.143v-1a.143.143 0 0 0-.143-.142M4 11.573h1a.143.143 0 0 0 .143-.143V8.858A.143.143 0 0 0 5 8.715H4a.143.143 0 0 0-.143.143v2.571c0 .079.064.143.143.143m2.714 0h1a.143.143 0 0 0 .143-.143V5.715a.143.143 0 0 0-.143-.143h-1a.143.143 0 0 0-.143.143v5.714c0 .079.064.143.143.143m2.714 0h1a.143.143 0 0 0 .143-.143V7.108a.143.143 0 0 0-.143-.143h-1a.143.143 0 0 0-.143.143v4.321c0 .079.065.143.143.143m2.715 0h1a.143.143 0 0 0 .142-.143V4.286a.143.143 0 0 0-.142-.143h-1a.143.143 0 0 0-.143.143v7.143c0 .079.064.143.143.143"
    />
  </svg>
);
export default SvgStatisticSidebar;
